import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgComparingVesselIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.858 17.8c0-.994.883-1.8 1.971-1.8h3.943c1.088 0 1.97.806 1.97 1.8v5.4h3.943c1.089 0 1.972.806 1.972 1.8v7.035l3.113.813c1.158.302 1.751 1.474 1.253 2.475l-3.667 7.367c-.64 1.285-2.043 2.11-3.589 2.11H13.834c-1.546 0-2.95-.825-3.59-2.11l-3.666-7.367c-.499-1.001.095-2.173 1.253-2.475l3.113-.812V25c0-.994.883-1.8 1.972-1.8h3.942zm1.971 5.4h3.943v-5.4h-3.943zm-5.913 8.321 7.343-1.916a2.15 2.15 0 0 1 1.083 0l7.343 1.916V25h-15.77zm7.884-.185L8.374 34.578l3.666 7.367c.32.642 1.022 1.055 1.795 1.055h13.933c.773 0 1.475-.413 1.794-1.055l3.667-7.367z"
    />
    <path
      fill="#F7F8F9"
      d="M20.8 31.336 8.374 34.578l3.666 7.367c.32.642 1.022 1.055 1.795 1.055h13.933c.773 0 1.475-.413 1.794-1.055l3.667-7.367z"
    />
    <path
      fill="#F7F8F9"
      d="m12.916 31.521 7.343-1.916a2.15 2.15 0 0 1 1.083 0l7.343 1.916V25h-15.77zM18.83 23.2h3.942v-5.4h-3.943z"
    />
    <path
      fill="currentColor"
      d="M33.347 12.267A2.667 2.667 0 0 1 36.014 9.6h5.333a2.667 2.667 0 0 1 2.667 2.667v8h5.333a2.667 2.667 0 0 1 2.667 2.666v10.423l4.212 1.203a2.667 2.667 0 0 1 1.695 3.668L52.96 49.14a5.33 5.33 0 0 1-4.856 3.127H29.256a5.33 5.33 0 0 1-4.855-3.127l-4.96-10.913a2.667 2.667 0 0 1 1.695-3.668l4.211-1.203V22.933a2.667 2.667 0 0 1 2.667-2.666h5.333zm2.667 8h5.333v-8h-5.333zm-8 12.327 9.934-2.838a2.67 2.67 0 0 1 1.465 0l9.934 2.838v-9.66H28.014zm10.667-.274-16.813 4.804 4.96 10.913a2.67 2.67 0 0 0 2.428 1.563h18.849a2.67 2.67 0 0 0 2.428-1.563l4.96-10.913z"
    />
    <path
      fill="#F7F8F9"
      d="m38.68 32.32-16.812 4.804 4.96 10.913a2.67 2.67 0 0 0 2.428 1.563h18.849a2.67 2.67 0 0 0 2.428-1.563l4.96-10.913z"
    />
    <path
      fill="#F7F8F9"
      d="m28.014 32.594 9.934-2.838a2.67 2.67 0 0 1 1.465 0l9.934 2.838v-9.66H28.014zM36.014 20.267h5.333v-8h-5.333z"
    />
  </svg>
)
export default SvgComparingVesselIcon
